import { Element, Option } from "../../../install/types.ts";

export const DatabaseHosting = Element({
  label: "Hosting",
  description: "How this instance is hosted",
  type: "select",
  step: "new",
  default: "aws-rds",
  options: {
    "aws-rds": Option({
      label: "AWS RDS",
      schema: {
        connectorArn: Element({
          label: "AWS Lambda ARN",
          description: "",
          type: "generated",
        }),
        instanceArn: Element({
          label: "AWS RDS ARN",
          description: "The ARN of this RDS instance",
          type: "string",
          step: "new",
        }),
        resourceId: Element({
          label: "AWS RDS resource ID",
          description: "The resource ID of the instance or cluster",
          type: "generated",
        }),
        vpcId: Element({
          label: "AWS RDS VPC ID",
          description: "The AWS RDS VPC installation that hosts this database",
          type: "dynamic",
          step: "new",
        }),
      },
    }),
    "gsm-static": Option({
      label: "GSM Static Credentials",
      schema: {
        connectorArn: Element({
          label: "AWS Lambda ARN",
          description: "",
          type: "generated",
        }),
        project: Element({
          label: "GCP Project",
          description: "GCP project that stores static credentials",
          type: "dynamic",
          step: "configure",
        }),
      },
    }),
  },
});
